import JoinForm from './JoinForm';

export default JoinForm;
